import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Button, Card, CardBody, IconButton, Typography} from "@material-tailwind/react";
import Footer from "./footer";
import {CheckCircle, User} from "lucide-react";

function Review() {
    const rightProps = {nextUrl: "/review", ready: false};
    const [searchParams, setSearchParams] = useSearchParams();
    const [progress, setProgress] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const saveBooking = async () => {
        try {
            localStorage.setItem("saveErrorMessage", "");
            const serviceIDs = [];
            const serviceNames = [];

            const serviceArray = JSON.parse(localStorage.getItem("services"));

            for (let i = 0; i < serviceArray.length; i++) {
                serviceIDs.push(serviceArray[i].id);
                serviceNames.push(serviceArray[i].name);
            }

            const postData = {
                customer: {
                    firstName: localStorage.getItem("firstname"),
                    lastName: localStorage.getItem("lastname"),
                    phone: localStorage.getItem("phone"),
                    email: localStorage.getItem("email"),
                },
                car: {
                    eid: localStorage.getItem("eid"),
                    make: localStorage.getItem("make"),
                    makeID: localStorage.getItem("makeID"),
                    model: localStorage.getItem("model"),
                    modelID: localStorage.getItem("modelID"),
                    year: localStorage.getItem("year"),
                    vin: localStorage.getItem("vin"),
                    mileage: localStorage.getItem("mileage"),
                    plate: localStorage.getItem("plate"),
                },
                book: {
                    servicenote: localStorage.getItem("servicenote"),
                    startBookDate:
                        localStorage.getItem("bookingtime").split(" ")[0] +
                        "T" +
                        localStorage.getItem("bookingtime").split(" ")[1],
                    branchID: "1",
                    serviceMemo: localStorage.getItem("memo"),
                    note: localStorage.getItem("bookMemo"),
                    serviceIDs: serviceIDs,
                },
            };

            setProgress(true);
            await new Promise((resolve) => setTimeout(resolve, 1100));

            await axios
                .post(process.env.REACT_APP_API_URL + "/api/v1/save/book", postData, {
                    withCredentials: true,
                })
                .then((response) => {
                    navigate("/complete");
                })
                .catch((error) => {
                    console.log(error);
                    localStorage.setItem("saveErrorMessage", error.response.error);
                    navigate("/error");
                });
            setProgress(false);
            const expires = new Date();
            // document.cookie = `Authorization=;expires=;path=`; //얘약하고 하면 쿠키 자동 삭제. 다시 예약 시도하지 못하도록 막음.
        } catch (e) {
            console.log(e);
            localStorage.setItem("saveErrorMessage", e);
            navigate("/error");
        }
    };

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-50">
                <div className="container mx-auto max-w-7xl px-4 py-4 sm:py-6">
                    {/* Enhanced Header with back button */}
                    <div className="mb-6 sm:mb-8">
                        <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                            <IconButton
                                variant="outlined"
                                color="blue-gray"
                                size="lg"
                                onClick={() => navigate("/contact")}
                                className="border-gray-300 hover:bg-gray-50 transition-all duration-300"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="currentColor"
                                    className="w-5 h-5 sm:w-6 sm:h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                                    />
                                </svg>
                            </IconButton>
                            <div>
                                <Typography variant="h4" color="blue-gray"
                                            className="font-bold text-xl sm:text-2xl lg:text-3xl">
                                    Reservation Details
                                </Typography>
                                <Typography variant="paragraph" color="gray" className="mt-1 text-sm sm:text-base">
                                    Please review your booking information
                                </Typography>
                            </div>
                        </div>

                        {/* Progress indicator */}
                        <div className="flex items-center justify-center mb-6 sm:mb-8 overflow-x-auto px-2 sm:px-4 overflow-y-hidden">
                            <div className="flex items-center justify-between w-full max-w-4xl">
                                {/* Step 1 - Select Services */}
                                <div className="flex items-center justify-center">
                                    <div className="flex items-center cursor-pointer" onClick={() => navigate("/services")}>
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0 cursor-pointer hover:bg-green-600 transition-colors duration-300"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        {/* Text label - hidden on mobile */}
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            Services
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 1 */}
                                <div className="flex-1 h-0.5 bg-blue-500 mx-2 sm:mx-4"></div>

                                {/* Step 2 - Schedule */}
                                <div className="flex items-center justify-center">
                                    <div className="flex items-center cursor-pointer" onClick={() => navigate("/schedule")}>
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0 cursor-pointer hover:bg-green-600 transition-colors duration-300"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        {/* Text label - hidden on mobile */}
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            Schedule
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 2 */}
                                <div className="flex-1 h-0.5 bg-blue-500 mx-2 sm:mx-4"></div>

                                {/* Step 3 - Car Information */}
                                <div className="flex items-center justify-center">
                                    <div className="flex items-center cursor-pointer" onClick={() => navigate("/carinfo")}>
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0 cursor-pointer hover:bg-green-600 transition-colors duration-300"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        {/* Text label - hidden on mobile */}
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            Car
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 3 */}
                                <div className="flex-1 h-0.5 bg-blue-500 mx-2 sm:mx-4"></div>

                                {/* Step 4 - Contact Information */}
                                <div className="flex items-center justify-center">
                                    <div className="flex items-center cursor-pointer" onClick={() => navigate("/contact")}>
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0 cursor-pointer hover:bg-green-600 transition-colors duration-300"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        {/* Text label - hidden on mobile */}
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            Contact
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 4 */}
                                <div className="flex-1 h-0.5 bg-blue-500 mx-2 sm:mx-4"></div>

                                {/* Step 5 - Review (CURRENT) */}
                                <div className="flex items-center justify-center relative">
                                    <div className="relative">
                                        {/* Pulsing ring animation - hidden on mobile */}
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-500 rounded-full animate-ping opacity-20 hidden sm:block"></div>
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-500 rounded-full animate-pulse opacity-30 hidden sm:block"></div>

                                        {/* Main step indicator */}
                                        <div className="relative w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-full flex items-center justify-center text-sm sm:text-base md:text-lg font-bold shadow-lg border-2 sm:border-4 border-white flex-shrink-0 z-10">
                                            5
                                        </div>
                                    </div>

                                    {/* Current step indicator - hidden on mobile */}
                                    <div className="ml-2 sm:ml-3 hidden sm:block">
                                        <Typography variant="small"
                                                    className="font-bold text-blue-600 text-sm sm:text-base whitespace-nowrap">
                                            Review
                                        </Typography>
                                        <div className="text-xs text-blue-500 font-medium">
                                            Current Step
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 justify-center">
                        {/* Enhanced Review Information Section */}
                        <div className="flex-1 max-w-xl">
                            <Card className="border border-gray-200 shadow-lg bg-white">
                                <CardBody className="p-6 lg:p-8">
                                    <div className="mb-8">
                                        <div className="flex items-center gap-3 mb-3">
                                            <div className="p-2 bg-blue-50 rounded-lg">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                     strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
                                                     className="w-6 h-6 text-blue-600">
                                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                                    <polyline points="14,2 14,8 20,8"/>
                                                    <line x1="16" y1="13" x2="8" y2="13"/>
                                                    <line x1="16" y1="17" x2="8" y2="17"/>
                                                    <polyline points="10,9 9,9 8,9"/>
                                                </svg>
                                            </div>
                                            <Typography variant="h5" color="blue-gray"
                                                        className="font-bold text-xl lg:text-2xl">
                                                Reservation Summary
                                            </Typography>
                                        </div>
                                        {/*<Typography variant="paragraph" color="gray"*/}
                                        {/*            className="text-base">*/}
                                        {/*    Please review all details before completing your reservation.*/}
                                        {/*</Typography>*/}
                                    </div>

                                    <div className="space-y-6">
                                        {/* Car Information */}
                                        <div className="bg-gray-50 p-5 rounded-lg border border-gray-200">
                                            <div className="flex items-center gap-3 mb-4">
                                                <div className="p-2 bg-white rounded-lg border border-gray-200">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                         viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                         strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
                                                         className="text-blue-600">
                                                        <path
                                                            d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/>
                                                        <circle cx="7" cy="17" r="2"/>
                                                        <path d="M9 17h6"/>
                                                        <circle cx="17" cy="17" r="2"/>
                                                    </svg>
                                                </div>
                                                <Typography variant="h6" className="font-semibold text-gray-800">
                                                    Vehicle Information
                                                </Typography>
                                            </div>
                                            <div className="ml-11 space-y-3">
                                                <div>
                                                    <Typography className="text-sm text-gray-600 mb-1">Vehicle</Typography>
                                                    <Typography className="font-semibold text-gray-900 text-lg">
                                                        {localStorage.getItem("make")} {localStorage.getItem("model")}{" "}
                                                        {localStorage.getItem("year")}
                                                    </Typography>
                                                </div>
                                                {localStorage.getItem("vin") && (
                                                    <div>
                                                        <Typography className="text-sm text-gray-600 mb-1">VIN</Typography>
                                                        <Typography className="font-medium text-gray-900">
                                                            {localStorage.getItem("vin")}
                                                        </Typography>
                                                    </div>
                                                )}
                                                {localStorage.getItem("plate") && (
                                                    <div>
                                                        <Typography className="text-sm text-gray-600 mb-1">License Plate</Typography>
                                                        <Typography className="font-medium text-gray-900">
                                                            {localStorage.getItem("plate")}
                                                        </Typography>
                                                    </div>
                                                )}
                                                {localStorage.getItem("mileage") && (
                                                    <div>
                                                        <Typography className="text-sm text-gray-600 mb-1">Mileage</Typography>
                                                        <Typography className="font-medium text-gray-900">
                                                            {localStorage.getItem("mileage")} miles
                                                        </Typography>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Customer Information */}
                                        <div className="bg-gray-50 p-5 rounded-lg border border-gray-200">
                                            <div className="flex items-center gap-3 mb-4">
                                                <div className="p-2 bg-white rounded-lg border border-gray-200">
                                                    <User className="w-5 h-5 text-green-600"/>
                                                </div>
                                                <Typography variant="h6" className="font-semibold text-gray-800">
                                                    Customer Information
                                                </Typography>
                                            </div>
                                            <div className="ml-11 space-y-3">
                                                <div className="flex flex-col sm:flex-row sm:items-center sm:gap-8">
                                                    <div className="min-w-0 flex-1">
                                                        <Typography className="text-sm text-gray-600 mb-1">Name</Typography>
                                                        <Typography className="font-medium text-gray-900">
                                                            {localStorage.getItem("firstname")}{" "}
                                                            {localStorage.getItem("lastname")}
                                                        </Typography>
                                                    </div>
                                                    <div className="min-w-0 flex-1 mt-3 sm:mt-0">
                                                        <Typography className="text-sm text-gray-600 mb-1">Phone</Typography>
                                                        <Typography className="font-medium text-gray-900">
                                                            {localStorage.getItem("phone")}
                                                        </Typography>
                                                    </div>
                                                </div>
                                                <div>
                                                    <Typography className="text-sm text-gray-600 mb-1">Email</Typography>
                                                    <Typography className="font-medium text-gray-900">
                                                        {localStorage.getItem("email")}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Appointment Information */}
                                        <div className="bg-gray-50 p-5 rounded-lg border border-gray-200">
                                            <div className="flex items-center gap-3 mb-3">
                                                <div className="p-2 bg-white rounded-lg border border-gray-200">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth="1.5"
                                                        stroke="currentColor"
                                                        className="w-5 h-5 text-purple-600"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                                                        />
                                                    </svg>
                                                </div>
                                                <Typography variant="h6" className="font-semibold text-gray-800">
                                                    Appointment Details
                                                </Typography>
                                            </div>
                                            <Typography className="font-semibold text-gray-900 text-lg ml-11">
                                                {localStorage.getItem("bookingtime").split(" ")[0]}{" "}
                                                at {localStorage.getItem("bookingtime").split(" ")[1]}
                                            </Typography>
                                        </div>

                                        {/* Services */}
                                        <div className="bg-gray-50 p-5 rounded-lg border border-gray-200">
                                            <div className="flex items-center gap-3 mb-4">
                                                <div className="p-2 bg-white rounded-lg border border-gray-200">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth="1.5"
                                                        stroke="currentColor"
                                                        className="w-5 h-5 text-orange-600"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z"
                                                        />
                                                    </svg>
                                                </div>
                                                <Typography variant="h6" className="font-semibold text-gray-800">
                                                    Selected Services
                                                </Typography>
                                            </div>
                                            <div className="ml-11 space-y-2">
                                                {JSON.parse(localStorage.getItem("services")).map(
                                                    (service, index) => (
                                                        <div key={index} className="flex items-center gap-3 py-2">
                                                            <CheckCircle className="w-4 h-4 text-green-600 flex-shrink-0"/>
                                                            <Typography className="font-medium text-gray-900">
                                                                {service.name}
                                                            </Typography>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>

                                        {/* Complete Button */}
                                        <div className="mt-8 pt-6 border-t border-gray-200">
                                            {progress ? (
                                                <Button
                                                    variant="gradient"
                                                    color="blue"
                                                    size="lg"
                                                    className="w-full py-4 text-lg font-semibold shadow-lg"
                                                    loading={true}
                                                    disabled
                                                >
                                                    Processing Your Reservation...
                                                </Button>
                                            ) : (
                                                <Button
                                                    onClick={saveBooking}
                                                    variant="gradient"
                                                    color="blue"
                                                    size="lg"
                                                    className="w-full py-4 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                                                >
                                                    Complete Reservation
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default Review;
